import { selectBuildingsInfoByTypeId } from "../../../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../../../utils/utilBuildings";
export var checkBuildingConstructionInProgressAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var taskType = action.taskType;
    var availableBuildings = selectBuildingsInfoByTypeId(state, taskType.buildingId);
    return availableBuildings.some(utilBuildings.isUnderConstruction) ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/have-building/checks/checkBuildingConstructionInProgressAvailable.ts
// module id = 2374
// module chunks = 3